import { createContext, useContext } from 'react';

import type { Locale } from './locales';

export type SetLocale = (locale: Locale) => void;

/** Context that exposes `setLocale` — provided by `IntlProviderShell`. */
export const LocaleSetterContext = createContext<SetLocale | null>(null);

export function useSetLocale(): SetLocale {
  const context = useContext(LocaleSetterContext);
  if (!context) {
    throw new Error('useSetLocale must be used inside <IntlProviderShell>.');
  }
  return context;
}
